import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import BEM from '@scripts/utilities/bem.js';


class ColumnHeader extends React.Component {
  get id() {
    return null;
  }

  get title() {
    return null;
  }

  get overlayText() {
    return null;
  }

  get rightAlign() {
    return false;
  }

  render() {
    var variant;

    var content = (
      <span>{this.title}</span>
    );
    if (this.overlayText) {
      content = (
        <OverlayTrigger overlay={this.overlay()}>
          {content}
        </OverlayTrigger>
      );
    }

    if (this.rightAlign) {
      return (
        <th className="text-right">
          {content}
        </th>
      );
    } else {
      return (
        <th>
          {content}
        </th>
      );
    }
  }

  overlay() {
    return (
      <Tooltip id={'asset-table-overlay-' + this.id}>{this.overlayText}</Tooltip>
    );
  }
}


class ColumnHeaderSortable extends ColumnHeader {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.setSort(this.id);
  }

  render() {
    var variant;

    if (this.props.sort) {
      variant = 'is-' + this.props.sort;
    }

    var content = (
      <span className="cs-sortable-table-header__content">{this.title}</span>
    );
    if (this.overlayText) {
      content = (
        <OverlayTrigger overlay={this.overlay()}>
          {content}
        </OverlayTrigger>
      );
    }

    if (this.rightAlign) {
      return (
        <th className={"text-right " + BEM.classString('cs-sortable-table-header', variant)} onClick={this.onClick}>
          {content}
        </th>
      );
    } else {
      return (
        <th className={BEM.classString('cs-sortable-table-header', variant)} onClick={this.onClick}>
          {content}
        </th>
      );
    }
  }
}


export { ColumnHeader, ColumnHeaderSortable };

